// @flow

import {DeepMap, FieldError} from 'react-hook-form';

export const getFormErrorsProgramatically = (
  errors: DeepMap<{[key: string]: any}, FieldError>
) => {
  return (Object.keys(errors): string[]);
};

export const getIsTabWithErrors = (
  evalFields: {field: string, withoutExactMatch: boolean}[],
  errorFields: string[]
) => {
  if (errorFields.length === 0) return false;

  for (let field of evalFields) {
    if (
      field.withoutExactMatch
        ? errorFields.find(el => el.startsWith(field.field))
        : errorFields.find(el => el === field.field)
    )
      return true;
  }

  return false;
};
